import script from "./TransactionsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TransactionsTable.vue?vue&type=script&lang=ts&setup=true"

import "./TransactionsTable.vue?vue&type=style&index=0&id=cb8a2056&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb8a2056"]])

export default __exports__